import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const polls = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
    answers: [],
    participants: [],
  }),
  mutations: {
    setPolls(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedPolls(state, payload) {
      state.selectedItems = payload;
    },
    setPollPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getPolls");
    },
    setPollTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getPolls");
    },
    setAnswers(state, payload) {
      state.answers = payload.items;
      state.participants = payload.participants;
    },
  },
  actions: {
    async togglePollActive(store, payload) {
      var res = await axios.post("poll/toggleisactive", {
        id: store.state.items[payload.index].id,
      });

      if (res.data.alert.hasError) {
        payload.context.$message.error(res.data.alert.message);
        store.state.items[payload.index].isActive = false;
        store.state.items[payload.index].isActiveAnswers = false;
        return;
      }

      if (
        store.state.items[payload.index].isActiveAnswers == true &&
        store.state.items[payload.index].isActive == false
      ) {
        store.state.items[payload.index].isActiveAnswers = false;
        store.dispatch("togglePollActiveAnswers", payload);
      }
    },
    async togglePollActiveAnswers(store, payload) {
      var res = await axios.post("poll/toggleisactiveanswers", {
        id: store.state.items[payload.index].id,
      });
      if (
        store.state.items[payload.index].isActive == false &&
        store.state.items[payload.index].isActiveAnswers
      ) {
        store.state.items[payload.index].isActive = true;
        store.dispatch("togglePollActive", payload);
      }
    },
    async sendPollNotification(store, payload) {
      var res = await axios.post("poll/sendnotification", {
        id: store.state.items[payload.index].id,
      });

      if (res.data.alert.hasError) {
        payload.context.$message.error(res.data.alert.message);
      } else {
        payload.context.$message.success(res.data.alert.message);
      }
    },
    async getPolls(store) {
      store.state.loading = true;
      await axios
        .post("poll/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setPolls", res.data.data);
        });
    },
    async getPoll(store, payload) {
      await axios
        .post("poll/get", {
          id: store.state.items[payload].id,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setAnswers", {
            items: res.data.data.item.votes,
            participants: res.data.data.participants,
          });
        });
    },
    async toggleSaloon(store, payload) {
      var res = await axios.post("poll/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deletePoll(store, payload) {
      await axios
        .post("poll/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setPollPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default polls;



// WEBPACK FOOTER //
// ./src/store/polls.js